'use strict';

if("production"==='development'){
require('source-map-support').install();
}

require('babel-polyfill');
require('./plugins');

const AngularHelpers=require('../../dist-es6/client/angularCommon/angularHelpers');

const optionalDeps=

[
require('./features/login'),
require('./features/groups'),
require('./features/profile'),
require('./features/helpCenter'),
require('./features/notificationSettings'),
require('./features/organizationProfile'),
require('./features/organizationUsers'),
require('./features/timelineSettings'),
require('./features/scenario'),
require('./features/terms'),
'angular-google-analytics',
'leaflet-directive'];







const optionalConfigs=

[require('./analyticsConfig')];

AngularHelpers.registerModule({
name:'fdc',
dependencies:[
require('angular-material'),
require('angular-animate'),
require('angular-aria'),
require('angular-messages'),
require('./services'),
require('./directives'),
require('./features/dashboard'),
require('./features/forecast'),
require('./features/fleetInsight'),
require('./features/flightMonitor'),
require('./features/personalSchedule'),
require('./features/fatigueReport'),
require('angular-cookies'),
'rx',
'ui.router',
'ui.timepicker',
'mm.foundation',
'templates'].
concat(optionalDeps),
configs:[
require('./fdcConfig')].
concat(optionalConfigs)});
//# sourceMappingURL=fdc.js.map
